import { Box } from '@mui/material';
import { ISvgIconStyleProps } from './SvgIconStyle.types';

const SvgIconStyle = ({ src, sx }: ISvgIconStyleProps) => {
  return (
    <Box
      component="span"
      sx={{
        width: 24,
        height: 24,
        display: 'inline-block',
        bgcolor: 'currentColor',
        mask: `url(${src}) no-repeat center / contain`,
        WebkitMask: `url(${src}) no-repeat center / contain`,
        ...sx,
      }}
    />
  );
};

export { SvgIconStyle };
